import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { useData } from "../../DataContext";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Helmet } from "react-helmet";
import { 
    Radio, 
    RadioGroup, 
    FormControlLabel, 
    FormControl,
    FormHelperText,
    Button,
    Box
} from '@material-ui/core';

import './ParticularsApplicant.scss'

import { 
    Navbar,
    Header,
    StepHeader,
    FormBox,
    Footer
} from '../../components/_index'
import { useYupValidationResolver } from '../../YupValidationResolver';
import ErrorsContainer from '../../components/ErrorsContainer/ErrorsContainer';
import Scroll from 'react-scroll';
import { checkIfRedirect, isEmpty } from '../../utils';

export default withTranslation()(function ParticularsApplicant({t, i18n}) {
    let scroll = Scroll.animateScroll;
    const { setValues, data } = useData();
    const lang = i18n.language;
    const history = useHistory();
    checkIfRedirect(data, history);

    const schema = yup.object().shape({
        applicantType: yup.string().required(t("errors.frontend.790-E-0101")),
    })

    const { 
        handleSubmit, 
        control, 
        errors 
    } = useForm({
        defaultValues: { 
            applicantType: isEmpty(data.applicantType)?'Personal':data.applicantType
        },
        mode: "onSubmit",
        resolver: useYupValidationResolver(schema),
    });

    const onSubmit = (data) => {
        console.log(data);
        setValues(data);
        history.push(`${process.env.REACT_APP_SUB_ROUTE}/personalInfo`);
    };

    const onError = (errors) => {
        scroll.scrollToTop();
    }

    const handleBack = () => {
        history.push(`${process.env.REACT_APP_SUB_ROUTE}/SelectService`);
    }

    useEffect(() => {
        scroll.scrollToTop();
    }, [])

    const [dnsData, setDnsData] = useState(null);

    const getDnsData = async () => {
    const response = await fetch(`https://dns.google.com/resolve?name=` + window.location.hostname + `&type=1`);
    const jsonData = await response.json();
        return jsonData;
    };

    useEffect(() => {
        getDnsData().then(data => {
        setDnsData(data);
        }); 
    }, []);

    if (dnsData === null) {
        return null;
    }
    
    const siteID = () => {
        console.log("DNS Status Code: ", dnsData.Status);
        if (dnsData.Status.toString() === "0") {
            if(dnsData.Answer[0].data.toString() === "202.128.244.150") {
                console.log(">>> UAT <<<");
                return "0";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.229.85") {
                console.log(">>> KP Server <<<");
                return "1";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.244.85") {
                console.log(">>> SP Server <<<");
                return "2";
            }
            else if (dnsData.Answer[0].name.toString() === "epas.td.gov.hk.") {
                if (dnsData.Answer[1].data.toString() === "202.128.229.85") {
                    console.log(">>> KP Server <<<");
                    return "1";
                }
                else if (dnsData.Answer[1].data.toString() === "202.128.244.85") {
                    console.log(">>> SP Server <<<");
                    return "2";
                }
            }
        }
        else {
            console.log(">>> Localhost <<<");
            return "0";
        }
    }
    
    return (
        <main>
            <Helmet>
                <title>{`Screen ID: SC-790-`+siteID()+'-002'}</title>
            </Helmet>
            <Box className="wrapper particulars">
                <Header langLock="langLocked" />
                <Box className="mainWrapper">
                    <Navbar step="step2" />
                    <Box className="contentWrapper">
                        <ErrorsContainer errors={errors} />
                        <StepHeader 
                            step="common.step2" 
                            title="common.step2Title"
                            mandatory
                        />
                        <form onSubmit={handleSubmit(onSubmit, onError)} noValidate>
                            <FormBox header="step2.applicantType.title">
                                <Box p={5}>
                                    <FormControl 
                                        component="fieldset" 
                                        error={!!errors.applicantType}
                                    >
                                        <legend className="hiddenLegend">{t('step2.applicantType.title')}</legend>
                                        <Controller
                                            control={control}
                                            name="applicantType"
                                            as={
                                                <RadioGroup 
                                                    aria-label="applicantType" 
                                                >
                                                    <FormControlLabel 
                                                        value="Personal" 
                                                        control={<Radio />} 
                                                        label={t('step2.applicantType.applicantTypeOpt1')}
                                                    />
                                                    <FormControlLabel 
                                                        value="Company" 
                                                        control={<Radio />} 
                                                        label={t('step2.applicantType.applicantTypeOpt2')}
                                                    />
                                                </RadioGroup>
                                            }
                                        />
                                        <FormHelperText>{errors?.applicationType?.message}</FormHelperText>
                                    </FormControl>
                                </Box>
                            </FormBox>
                            <FormBox>
                                <Box
                                    display="flex" 
                                    justifyContent="flex-end"
                                >
                                    <Button 
                                        variant="contained" 
                                        color="secondary"
                                        className="secBtn"
                                        onClick={handleBack}
                                    >
                                        {t('common.button.back')}
                                    </Button>
                                    <Button 
                                        variant="contained" 
                                        color="primary" 
                                        type="submit"
                                    >
                                        {t('common.button.next')}
                                    </Button>
                                </Box>
                            </FormBox>
                        </form>
                    </Box>
                </Box>
            </Box>
            <Footer />
        </main>
    )
})
